<script>
import { mapStores } from "pinia";
import { defineComponent } from "vue";

import { translateLanguageGroup } from "@/common/language-group-helpers";
import { useModalStore, useSettingsStore } from "@/stores";

export default defineComponent({
  name: "LanguageSelectorButton",
  computed: {
    ...mapStores(useSettingsStore, useModalStore),

    activeLanguageGroup() {
      return this.settingsStore.activeLanguageGroup;
    },

    translatedActiveLanguageGroup() {
      return translateLanguageGroup(this.activeLanguageGroup);
    }
  },
  methods: {
    openModal() {
      this.modalStore.setModalState("languageSelector", true);
    }
  }
});
</script>

<template>
  <button
    class="language-selector-button"
    :aria-label="
      $t('languageSelector.languageSelectorButtonAriaLabel', {
        language: translatedActiveLanguageGroup
      })
    "
    aria-haspopup="true"
    @click="openModal()"
  >
    <span v-if="activeLanguageGroup">
      <span>
        <img
          class="language-selector-button__flag"
          :src="`/assets/img/language-group-button-${activeLanguageGroup}@1x.png`"
          alt=""
        />
      </span>
      <span class="language-selector-button__label">&nbsp;{{ translatedActiveLanguageGroup }}</span>
    </span>
  </button>
</template>
